export default __webpack_public_path__ + "static/media/crop.cc24ce83.svg";